const RUC = '1'
const CODIGO = '2'

const __dictionary = {
  [RUC]: {
    id: RUC,
    nombre: 'RUC'
  },
  [CODIGO]: {
    id: CODIGO,
    nombre: 'CODIGO'
  }
}

const __array = [__dictionary[RUC], __dictionary[CODIGO]]

export default Object.freeze({
  RUC,
  CODIGO,
  __dictionary,
  __array
})
